import React, { useEffect, useState } from 'react'
//import { fechaActual } from '../../../hooks/UseDate';
import { postHGDataSuministro } from '../../../services/PaginaRuta';
import ModalSuministrosIngresoCantidad from './ModalSuministrosIngresoCantidad';
import Loading from '../../Loading';
import ModalNotieneSuministrosHG from './ModalNotieneSuministrosHG';
import { desencriptarData } from '../../../services/encryption';



const ModalGastosCirugiaHG = ({setmodalOnGastosCirugia,informacionUser, passDataHojaGasto}) => {
  const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const [dataSuministros, setdataSuministros]=useState([])
    const [cantidadData, setCantidadData] = useState([]);
    const [modalOnSuministroIngresoCantidad, setmodalOnSuministroIngresoCantidad]=useState(false)
    const [cantidadSuministrosCorrectos, setcantidadSuministrosCorrectos]=useState([])
    const [modalOnNoTieneSuministros, setmodalOnNoTieneSuministros]=useState(false)
    
    const [loading,setloading]=useState(false)
   const handleCancelarClick=()=>{
    setmodalOnGastosCirugia(false)
   }
    useEffect(()=>{
      console.log(informacionUser,'informacionUser')
      setloading(false)
        const suministros={
            ProEmpCod:usuarioInfo.Empresa,
            ProMCDpto: usuarioInfo.Sede,
            ProCirCod: informacionUser.ProCirCod,
            PaqCod: informacionUser.PaqCod,
            PQEdoCaI: 'N', //Indicador de cancelación item paquete
            PQTpoTRN:'DS', //Tipo de Transacción
            PQEdoDes: 'V',
            PaqIndAct: 'S'
          }
          postHGDataSuministro(suministros).then((res)=>{
            console.log(res.data,'suministrosd')
            setloading(true)
            if(res.data.error !== 'Undefined array key 0'){
              let arraTotalSuministro =res.data.map((item)=>{
                return {
                  ...item,
                  cantidad: '',
                  error:'',
                  PQAplUsu:desencriptarData(item.PQAplUsu.trim())
              }
              })
              setdataSuministros(arraTotalSuministro)
              
            }      
            
          })
    },[])



    //
    const handleInputChange = (e, index) => {
        
      let uso =0
      if(dataSuministros[index].PQCaSuUs === '.0000'){
        uso = 0
      }else if(dataSuministros[index].PQCaSuUs !== '.0000'){
        uso = parseInt(dataSuministros[index].PQCaSuUs)
      }


      let error = '';
        if(((uso + parseInt(e.target.value)) > dataSuministros[index].PQCaSuDs) ||  e.target.value <= 0 ){
        //seterrorSeleccionarCantidad('La cantidad de movimiento no puede ser mayor a la cantidad despachada')
        console.log('La cantidad es incorrecta, por favor validar!!')
        
        error = 'Error Cantidad'
        }

        // Actualizar el estado de las filas
        const newRows = [...dataSuministros];
        newRows[index] = {...newRows[index], error };
        setdataSuministros(newRows)

    
      
    //   if(((uso + parseInt(e.target.value)) > dataSuministros[index].PQCaSuDs) ||  e.target.value <= 0 ){
    //     //seterrorSeleccionarCantidad('La cantidad de movimiento no puede ser mayor a la cantidad despachada')
    //     console.log('La cantidad es incorrecta, por favor validar!!')
    //   }else{
        const cantidad = e.target.value;
        
        const item = dataSuministros[index];
    
        setCantidadData(oldArray => {
            const foundItem = oldArray.find(oldItem => oldItem.MSRESO === item.MSRESO);
    
            if (foundItem) {
                return oldArray.map(oldItem => 
                    oldItem.MSRESO === item.MSRESO 
                        ? {...oldItem, cantidad: cantidad}
                        : oldItem
                );
            } else {
                return [...oldArray, {...item, cantidad: cantidad}];
            }
         });
    // }
}

  const handleInputObservaciones = (e,index)=>{
    const observaciones = e.target.value;
        
        const item = dataSuministros[index];
    
        setCantidadData(oldArray => {
            const foundItem = oldArray.find(oldItem => oldItem.MSRESO === item.MSRESO);
    
            if (foundItem) {
                return oldArray.map(oldItem => 
                    oldItem.MSRESO === item.MSRESO 
                        ? {...oldItem, PQAplObs: observaciones}
                        : oldItem
                );
            } else {
                return [...oldArray, {...item, PQAplObs: observaciones}];
            }
         });

         setdataSuministros(oldArray => {
          const foundItem = oldArray.find(oldItem => oldItem.MSRESO === item.MSRESO);
  
          if (foundItem) {
              return oldArray.map(oldItem => 
                  oldItem.MSRESO === item.MSRESO 
                      ? {...oldItem, PQAplObs: observaciones}
                      : oldItem
              );
          } else {
              return [...oldArray, {...item, PQAplObs: observaciones}];
          }
       });
  }

    const handleClickGuardarCantidadesSuministros =()=>{
        const errorCantidades = cantidadData.filter((item)=>{
            let uso =0
            if(item.PQCaSuUs === '.0000'){
                uso = 0
            }else if(item.PQCaSuUs !== '.0000'){
                uso = parseInt(item.PQCaSuUs)
            }
            
            if(item.cantidad){
                if((uso + parseInt(item.cantidad)) > item.PQCaSuDs){
                     return item
                  }
            }
            if(item.cantidad.startsWith("-")){
                return item
            }
            if(item.cantidad === "0"){
                return item
            }else  if(item.cantidad.startsWith("0")){
                return item
            }            
        })
        console.log(errorCantidades,'errorCantidades')
        // Convertir suministrosConErrorCantidades en un Set de ids
        let suministrosConErrorCantidades = new Set(errorCantidades.map(obj => obj.MSRESO));

        // Filtrar todos los elementos, conservando sólo aquellos que no están en suministrosConErrorCantidades
        let suministrosConCantidadCorrecta = cantidadData.filter(obj => {
            if(obj.cantidad){
                return !suministrosConErrorCantidades.has(obj.MSRESO)
            }
            } );

        console.log(suministrosConCantidadCorrecta,'suministrosConCantidadCorrecta');

        if(suministrosConCantidadCorrecta.length === 0){
          //console.log('Si entro')
          setmodalOnNoTieneSuministros(true)
        }else{
          //console.log('No entro')
          setcantidadSuministrosCorrectos(suministrosConCantidadCorrecta)
          setmodalOnSuministroIngresoCantidad(true)
        }

        
    }



    console.log(cantidadData,'cantidadData')
    return (
        <>
        <div
          className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
          id="exampleModalScrollable"
          tabIndex="-1"
          aria-labelledby="exampleModalScrollableLabel"
          aria-hidden="true"
        >
          <div className="sm:h-[calc(100%)]  mx-auto relative w-auto pointer-events-none ">
            <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
              <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
                <h5
                  className="text-xl font-medium leading-normal text-white"
                  id="exampleModalScrollableLabel"
                >
                  Gastos de Cirugía 
                </h5>
                <button
                  type="button"
                  onClick={handleCancelarClick}
                  className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  X
                </button>
              </div>
              <div className="flex-auto overflow-y-auto relative p-2">
                <form >
                  <div className="flex py-2 text-left">
                    <div className="w-1/3  px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Cirugía
                      </label>
                      <div className="flex">
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          defaultValue={informacionUser.ProCirCod}
                          disabled={true}
                          type="number"
                          name="cedula"
                          autoComplete="off"
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                      </div>
                    </div>
                    <div className="w-1/3  px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Paquete
                      </label>
                      <div className="flex">
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          //defaultValue={props.userDate.ProEmpCod}
                          defaultValue={informacionUser.PaqCod}
                          disabled={true}
                          name="codigoMedico"
                          type="text"
                          autoComplete="off"
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        {/* <label className="px-2"></label>
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          //defaultValue={props.userDate.ProEmpCod}
                          name="nombre"
                          type="text"
                          autoComplete="off"
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        /> */}
                      </div>
                    </div>
                  </div>
                  <div className="flex py-2 text-left">
                    <div className="w-1/3  px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Tipo de Documento 
                      </label>
                      <div className="flex">
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          defaultValue={informacionUser.MPTDoc}
                          //name="especialidadMedico"
                          disabled={true}
                          type="text"
                          autoComplete="off"
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        
                      </div>
                    </div>
                    <div className="w-1/3  px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Número Documento 
                      </label>
                      <div className="flex">
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          defaultValue={informacionUser.MPCedu}
                          //name="especialidadMedico"
                          disabled={true}
                          type="text"
                          autoComplete="off"
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        
                      </div>
                    </div>
                    <div className="w-1/3  px-1">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Nombre
                      </label>
                      <div className="flex">
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          defaultValue={informacionUser.MPNOMC}
                          //name="especialidadMedico"
                          disabled={true}
                          type="text"
                          autoComplete="off"
                          className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        {/* <button
                          type="submit"
                          className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                        >
                          Buscar
                        </button> */}
                      </div>
                    </div>
                  </div>
                  <div className="flex py-2 text-left">
                    
                    <div className="w-1/3  px-1 flex">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Totalmente Diligenciado 
                      </label>
                      <div className="px-2">
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          //defaultValue={informacionUser.MPCedu}
                          //name="especialidadMedico"
                          disabled={true}
                          type="text"
                          autoComplete="off"
                          className="form-control block w-20 px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#fef9c3] bg-clip-padding    transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        
                      </div>
                    </div>
                    <div className="w-1/3  px-1 flex">
                      <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Parcialmente Diligenciado
                      </label>
                      <div className="px-3">
                        <input
                          //   onChange={searchUserId}
                          //defaultValue={props.userDate[0].ProEmpCod}
                          //defaultValue={informacionUser.MPNOMC}
                          //name="especialidadMedico"
                          disabled={true}
                          type="text"
                          autoComplete="off"
                          className="form-control block w-20 px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#bbf7d0] bg-clip-padding    transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                          id="exampleFormControlInput1"
                          placeholder=""
                        />
                        {/* <button
                          type="submit"
                          className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                        >
                          Buscar
                        </button> */}
                      </div>
                    </div>
                  </div>
                </form>
                <div className="flex flex-col">
            <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
                <div className="py-2 inline-block min-w-full">
                <div className="overflow-auto md:overflow-visible">
                    <table className="min-w-full text-center bg-gray-200">
                          <thead className="">
                            <tr>
                              <th></th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                N°.Cir.
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                Paq.
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                Desc.Paq.
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                Suministro
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                Descripción.
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                Desp.
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                Devlto.
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                Uso Prev
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                Ingresar Cantidad
                              </th>
                              {/* <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Cnt. Mov
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-6 py-4"
                              >
                                Sel
                              </th> */}
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                Apl.
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                Fch/Hora Apl.
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                Observación Aplicación.
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                Usu. Aplica
                              </th>
                              <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-4"
                              >
                                Estado Diligenciado.
                              </th>
                              
                            </tr>
                          </thead>
                          <tbody className='rounded-none'>
                            {
                              loading?
                              dataSuministros.map((item,index)=>(                            
                                <tr key={index} className={item.PQCaSuDs == item.PQCaSuUs? 'divide-y divide-slate-700 bg-[#fef9c3] rounded-none': (parseInt(item.PQCaSuDs) > 1) && (item.PQCaSuUs != '.0000')? 'divide-y divide-slate-700 bg-[#bbf7d0]':'divide-y divide-slate-700'}>
                                    <td></td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                      
                                      {item.ProCirCod? item.ProCirCod:null}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap ">
                                      
                                      {item.PaqCod? item.PaqCod:null}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
                                      {item.PaqDes? item.PaqDes.trim():null}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap ">
                                      
                                      {item.MSRESO? item.MSRESO:null}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap text-left">
                                      {item.MSNomG? item.MSNomG:null}
                                      
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                      {item.PQCaSuDs}
                                      
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                      
                                      {item.PQCaSuDv}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                        {item.PQCaSuUs}
                                        </td>
    
                                    
                                      {
                                        (item.PQCaSuDs !== item.PQCaSuUs) && (item.PQCaSuDv === 0 || item.PQCaSuDv === '.0000') 	?
                                        <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                        <input
                                        className="shadow appearance-none border rounded w-24 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                        //placeholder={placeholder}
                                        //value={value}
                                        //onChange={onChange}
                                        type='number'
                                        onChange={(e) => handleInputChange(e, index)}
                                        />
                                        {item.error && <p className="text-red-500 mt-1">{item.error}</p>}
                                        </td>
                                        :<td></td>
                                      }
                                    
                                    
                                    
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap">
                                      
                                      {item.PQAplSum == 'S'? 'Si': 'No'}
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap 	">
                                      
                                      {item.PQAplFHor}
                                    </td>
                                    <td className="text-xs font-medium py-1 whitespace-pre-wrap ">
                                      {
                                        (item.PQCaSuDs !== item.PQCaSuUs) && (item.PQCaSuDv === 0 || item.PQCaSuDv === '.0000')	?
                                        <textarea 
                                        className="shadow appearance-none border rounded w-30 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                        defaultValue={item.PQAplObs}                                        
                                        type='text'
                                       onChange={(e) => handleInputObservaciones(e, index)}
                                        />
                                        : `${item.PQAplObs? item.PQAplObs:'' }` 
                                      }
                                      
                                      
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap ">
                                      {item.PQAplUsu? item.PQAplUsu:null}
                                      
                                    </td>
                                    <td className="text-xs font-medium py-2 whitespace-pre-wrap ">
                                      
                                      {item.PQEdoIte == 'P'? 'Parcialmente diligenciado': (item.PQEdoIte == 'D'? 'Totalmente diligenciado':'Sin diligenciar' )}
                                    </td>
                                    
                                </tr>
                                
                              ))
                              :
                              <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td><Loading/></td>
                              </tr>
                              
                            }
                          
                          
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
                <button
                  type="button"
                  onClick={handleCancelarClick}
                  className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
                <button
                //type="submit"
                onClick={handleClickGuardarCantidadesSuministros}
                className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Guardar
              </button>
              </div>
            </div>
          </div>
        </div>
        {modalOnSuministroIngresoCantidad? <ModalSuministrosIngresoCantidad setmodalOnSuministroIngresoCantidad={setmodalOnSuministroIngresoCantidad} cantidadSuministrosCorrectos={cantidadSuministrosCorrectos} informacionUser={informacionUser} passDataHojaGasto={passDataHojaGasto} handleCancelarClickModalCirugia={handleCancelarClick}/>: null}
        {modalOnNoTieneSuministros? <ModalNotieneSuministrosHG setmodalOnNoTieneSuministros={setmodalOnNoTieneSuministros}/>:null}
        </>
    );
}

export default ModalGastosCirugiaHG